const noEl = () => null;

export default noEl;
